<template lang="pug">
    div
      content-loader(:height="7", v-if="alert.loading")
      div.mb-3.pb-3(v-else-if="rentals.length > 0")
        b-container
          .container(v-for="rental in rentals", :key="rental.id")
            .row
              .col-8
                h4.mt-0 {{ rental.art_title }}
                b-badge.mb-1(variant="dark") {{ rental.status.toUpperCase() }}
                p.mb-0(v-if="rental.status === 'active'")
                p.mb-0(v-else-if="rental.status === 'pending'") This rental will be activated upon delivery
                p.mb-0(v-else="") {{ `This rental ended on ${rental.date_end_pretty}` }}
              .col-4.text-right
                b-button.btn-outline(v-if="rental.status !== 'pending'", @click="openRow(rental)") VIEW RENTAL
            hr
          p Active rentals will automatically renew at the end of each term.
      nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      rentals: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'id', label: 'Ref#', sortable: true },
        { key: 'art_title', label: 'Piece' },
        { key: 'compAmount', label: 'Rate' },
        { key: 'date_end_pretty', label: 'Term Ends' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: 'Return' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.rentals.length;
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'rental', params: { rentalId: row.id } });
    },
  },
  async created() {
    this.loading();
    this.rentals = await apiService.getRentals();
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AccountRentals.vue